/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface FeedbackAnswerDetail {
  dateCreated?: Date;
  formId?: number;
  groupId?: number;
  optionId?: number;
  optionText?: string;
  personId?: number;
  personName?: string;
  questionId?: number;
  title?: string;
  typeId?: number;
  typeIdName?: string;
}
